<template>
  <div class="c-faq">
    <div
      class="c-faqLoggedIn"
      v-if="isLoggedIn && !isMyRequest && !requestDetail.outline.isExpired"
    >
      <div
        class="c-faqForm"
        v-if="!displayFaqForm && !isPC"
      >
        <c-button-v2
          color="secondary"
          size="ms"
          width="100%"
          @click="displayFaqForm = true"
        >
          依頼者へ質問
        </c-button-v2>
      </div>
      <div
        class="c-faqForm"
        v-if="displayFaqForm || isPC"
      >
        <div class="c-faqFormRow c-faqFormInput">
          <div
            class="c-faqFormIcon"
            v-if="isPC"
          >
            <c-user-icon
              :file-path="user.icon"
              :user-name="user.name"
              :size="48"
            />
          </div>
          <div class="c-faqFormInput">
            <c-input-v2
              type="textarea"
              :rows="questionInputRows"
              :minlength="QUESTION_MIN_LENGTH"
              :maxlength="QUESTION_MAX_LENGTH"
              placeholder="依頼内容への質問を記入してください。
投稿した質問は全体に公開されますのでご注意ください"
              v-model="questionInput"
              @validate="validateQuestionInput"
            />
          </div>
        </div>
        <div class="c-faqFormRow c-faqFormButton">
          <c-button-v2
            v-if="isPC"
            color="secondary"
            size="m"
            width="200px"
            :disabled="!isValidQuestionButton"
            @click="addQuestion"
          >
            公開質問を送る
          </c-button-v2>
          <c-button-v2
            v-else
            color="secondary"
            size="ms"
            width="100%"
            :disabled="!isValidQuestionButton"
            @click="addQuestion"
          >
            公開質問を送る
          </c-button-v2>
        </div>
        <b-loading
          :active="isLoadingQuestion"
          :is-full-page="false"
        />
      </div>
    </div>
    <h4 v-if="isPC">質問と回答の履歴</h4>
    <div
      class="c-faqItems_empty"
      v-if="isLoadingList"
    >
      <b-loading
        :active="isLoadingList"
        :is-full-page="false"
      />
    </div>
    <div v-else-if="questionsList.length">
      <div class="c-faqItems">
        <template v-for="item in displayFaq">
          <div
            class="c-faqItem"
            :key="item.id"
          >
            <div class="c-faqItem_question">
              <div class="c-faqItemQuestionUser">
                <a
                  :href="'/users/' + item.user.id"
                  target="_blank"
                  rel="noopener"
                >
                  <c-user-icon-v2
                    :file-path="item.user.icon"
                    :user-name="item.user.name"
                    :size="questionIconSize"
                  />
                </a>
              </div>
              <div class="c-faqItemQAContent">
                <div class="c-faqItemQAContent_header">
                  <div>
                    <a
                      :href="'/users/' + item.user.id"
                      target="_blank"
                      rel="noopener"
                    >
                      {{ item.user.name }}
                    </a>
                  </div>
                  <div class="c-faqItemQAContentDate">
                    {{ $util.prettyDate(item.modified) }}
                  </div>
                </div>
                <contents-faq-item-content
                  :content="item.message"
                  :is-my-request="isMyRequest"
                />
              </div>
            </div>
            <div
              class="c-faqItem_answer"
              v-if="item.answer && Object.keys(item.answer).length"
            >
              <div class="c-faqItem_answerInner">
                <div class="c-faqItemAnswerUser">
                  <a
                    :href="'/users/' + item.answer.user.id"
                    target="_blank"
                    rel="noopener"
                  >
                    <c-user-icon-v2
                      :file-path="item.answer.user.icon"
                      :user-name="item.answer.user.name"
                      :size="answerIconSize"
                    />
                  </a>
                </div>
                <div class="c-faqItemQAContent">
                  <div class="c-faqItemQAContent_header">
                    <div>
                      <a
                        :href="'/users/' + item.answer.user.id"
                        target="_blank"
                        rel="noopener"
                      >
                        {{ item.answer.user.name }}
                      </a>
                    </div>
                    <div class="c-faqItemQAContentDate">
                      {{ $util.prettyDate(item.answer.created) }}
                    </div>
                  </div>
                  <contents-faq-item-content
                    :content="item.answer.message"
                    :is-my-request="isMyRequest"
                  />
                </div>
              </div>
            </div>
            <div
              class="c-faqItem_answer c-faqItem_answer-input"
              v-else-if="isMyRequest && !requestDetail.outline.isExpired"
            >
              <div class="c-faqItem_answerInner">
                <div
                  class="c-faqItemAnswerUser"
                  v-if="isPC"
                >
                  <a
                    href="#"
                    target="_blank"
                  >
                    <c-user-icon-v2
                      :file-path="requester.icon"
                      :user-name="requester.name"
                      :size="answerIconSize"
                    />
                  </a>
                </div>
                <div class="c-faqItemQAContent">
                  <c-input-v2
                    type="textarea"
                    :rows="answerInputRows"
                    :minlength="ANSWER_MIN_LENGTH"
                    :maxlength="ANSWER_MAX_LENGTH"
                    :placeholder="'質問への回答を' + ANSWER_MIN_LENGTH + '文字以上で記入してください'"
                    v-model="answerInput[item.id]"
                  />
                  <c-button-v2
                    color="primary-blue"
                    size="ms"
                    :width="answerButtonWidth"
                    :disabled="!isValidAnswerInput(item.id)"
                    @click="addAnswer(item.id)"
                  >
                    回答を送る
                  </c-button-v2>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div
        class="c-readMoreFaq"
        v-if="faqNeedReadMore && !faqExpanded"
      >
        <a @click="faqReadMore()">
          もっと見る
          <coconala-icon
            name="chevron-down"
            size="11px"
          />
        </a>
      </div>
    </div>
    <div
      class="c-faqItems_empty"
      v-else
    >
      質問はまだありません。不明なことがあれば質問してみましょう。
    </div>
  </div>
</template>
<script>
import ContentsFaqItemContent from './ContentsFaqItemContent'

import { mapGetters, mapState } from 'vuex'

// constants
const FAQ_NOT_EXPANSION_LIMIT_ROWS = 2
const FAQ_SLICE_ROWS = 4
const QUESTION_MIN_LENGTH = 10
const QUESTION_MAX_LENGTH = 2000
const ANSWER_MIN_LENGTH = 10
const ANSWER_MAX_LENGTH = 2000

export default {
  name: 'ContentsFaq',
  components: {
    ContentsFaqItemContent
  },
  props: {
    isMyRequest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      QUESTION_MIN_LENGTH,
      QUESTION_MAX_LENGTH,
      ANSWER_MIN_LENGTH,
      ANSWER_MAX_LENGTH,
      faqExpanded: false,
      faqOffset: 0,
      displayFaqForm: false,
      isLoadingList: true,
      isLoadingQuestion: false,
      questionInput: '',
      answerInput: {},
      isValidQuestion: false,
      isValidAnswer: {}
    }
  },
  mounted() {
    this.getQuestions()
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapState('auth', ['user']),
    ...mapState('pages/requests/request', ['questionsList', 'requestDetail', 'requester']),
    questionInputRows() {
      if (this.isPC) {
        return 6
      }
      return 4
    },
    answerInputRows() {
      if (this.isPC) {
        return 4
      }
      return 4
    },
    answerButtonWidth() {
      if (this.isPC) {
        return '120px'
      }
      return '100%'
    },
    questionIconSize() {
      if (this.isPC) {
        return 40
      }
      return 30
    },
    answerIconSize() {
      if (this.isPC) {
        return 24
      }
      return 24
    },
    faqNeedReadMore() {
      if (this.isMyRequest || !this.questionsList.length) {
        return false
      }

      if (this.questionsList.length > FAQ_NOT_EXPANSION_LIMIT_ROWS) {
        return true
      }

      return false
    },
    displayFaq() {
      if (this.faqNeedReadMore) {
        const displayNum = FAQ_NOT_EXPANSION_LIMIT_ROWS + FAQ_SLICE_ROWS * this.faqOffset
        return this.questionsList.slice(0, displayNum)
      }
      return this.questionsList
    },
    isValidQuestionButton() {
      // フォームが空のときはエラー表示しないが送信はできない
      return this.isValidQuestion && this.questionInput.length > 0 && !this.isLoadingList
    }
  },
  methods: {
    async getQuestions() {
      this.isLoadingList = true
      await this.$store
        .dispatch('pages/requests/request/getQuestions', {
          params: { requestId: this.requestDetail.id }
        })
        .catch(() => {
          this.$notify({
            group: 'flash',
            title: '質問の取得に失敗しました',
            type: 'error'
          })
        })
      this.isLoadingList = false
    },
    async addQuestion() {
      this.isLoadingQuestion = true
      try {
        await this.$store.dispatch('pages/requests/request/addQuestion', {
          params: {
            requestId: this.requestDetail.id,
            message: this.questionInput
          }
        })
        this.questionInput = ''
        this.isLoadingQuestion = false
        this.$notify({
          group: 'flash',
          title: '質問を送りました',
          type: 'success'
        })
        await this.getQuestions()
      } catch (grpcCode) {
        this.isLoadingQuestion = false
        this.$notify({
          group: 'flash',
          title: '処理に失敗しました',
          type: 'error'
        })
      }
    },
    async addAnswer(questionId) {
      this.isLoadingList = true
      try {
        await this.$store.dispatch('pages/requests/request/addAnswer', {
          params: {
            questionId,
            message: this.answerInput[questionId]
          }
        })
        this.answerInput[questionId] = ''
        await this.getQuestions()
        this.$notify({
          group: 'flash',
          title: '質問に回答しました',
          type: 'success'
        })
      } catch (grpcCode) {
        this.isLoadingList = false
        this.$notify({
          group: 'flash',
          title: '処理に失敗しました',
          type: 'error'
        })
      }
    },
    validateQuestionInput(isValid) {
      this.isValidQuestion = isValid
    },
    isValidAnswerInput(questionId) {
      // 回答のc-input-v2の@validateは発火タイミングの関係で使いにくいため、ここでバリデーションをする
      if (this.isLoadingList) {
        // 読込中は送信ボタンを押せないようにする
        return false
      }

      if (!this.answerInput[questionId]) {
        return false
      }

      const answerLength = this.answerInput[questionId].length
      if (ANSWER_MIN_LENGTH <= answerLength && answerLength <= ANSWER_MAX_LENGTH) {
        return true
      }

      return false
    },
    faqReadMore() {
      this.faqOffset++

      if (this.displayFaq.length === this.questionsList.length) {
        this.faqExpanded = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  @include link-effect;
}

h4 {
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 14px;
}

.c-faqForm {
  position: relative;
}

.c-faqFormRow {
  display: flex;

  .c-faqFormIcon {
    flex: 0 0 48px;
    margin-right: 20px;
  }

  .c-faqFormInput {
    flex: 1 1 auto;
  }

  &.c-faqFormButton {
    padding: 12px 0 40px 40px;
    text-align: center;

    /deep/ button {
      margin: 0 auto;
      width: 200px;
    }
  }
}

.c-faqRow {
  display: flex;

  &:last-child {
    border-bottom: none;
  }
}

.c-faqItem {
  & + & {
    margin-top: 20px;
  }

  &_question {
    display: flex;
  }

  &_answer {
    margin: 24px 0 20px 60px;

    &-input {
      position: relative;
      height: 168px;
      border-radius: 5px;

      .c-buttonV2 {
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  }

  &_answerInner {
    display: flex;
  }
}

.c-faqItemQuestionUser {
  flex: 0 0 40px;
  margin-right: 20px;
}

.c-faqItemAnswerUser {
  flex: 0 0 24px;
  margin-right: 12px;
}

.c-faqItemQAContent {
  flex: 1 1 auto;

  &_header {
    display: flex;
    margin-bottom: 8px;
    line-height: 1;

    justify-content: space-between;
  }
}

.c-faqItemQAContentDate {
  color: $color-gray-600;
  font-size: 11px;
}

.c-readMoreFaq {
  margin: 8px 0;
  color: $color-blue-500;
  font-size: 13px;
}

.c-faqItems {
  &_empty {
    position: relative;
    display: flex;
    padding: 12px;
    width: 100%;
    height: 80px;
    background-color: $color-gray-50;
    font-size: 14px;

    align-items: center;
    justify-content: center;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-faq {
    border-bottom: 1px solid $color-gray-200;
  }

  .c-faqForm {
    padding: 12px;
    border-bottom: 1px solid $color-gray-50;
  }

  .c-faqFormRow {
    display: flex;

    .c-faqFormIcon {
      flex: 0 0 48px;
      margin-right: 20px;
    }

    .c-faqFormInput {
      flex: 1 1 auto;
    }

    &.c-faqFormButton {
      padding: 8px 0 0;

      /deep/ button {
        width: 100%;
      }
    }
  }

  .c-faqItem {
    margin-bottom: 0;
    border-bottom: 1px solid $color-gray-50;

    & + & {
      margin-top: 0;
    }

    &_question {
      padding: 16px;
    }

    &_answer {
      margin: 0;
      padding: 0 16px 16px;

      &-input {
        padding: 12px 16px 16px;
        height: auto;

        .c-buttonV2 {
          position: static;
          margin-top: 12px;
        }
      }
    }
  }

  .c-faqItemQuestionUser {
    flex: 0 0 30px;
    margin-right: 8px;
  }

  .c-faqItemAnswerUser {
    flex: 0 0 30px;
    margin-right: 8px;
  }

  .c-faqItemQAContent {
    &_header {
      flex-direction: column;

      justify-content: flex-start;
    }
  }

  .c-faqItemQAContentDate {
    margin-top: 8px;
  }

  .c-readMoreFaq {
    margin: 0;
    padding: 12px 0;
    border-bottom: 1px solid $color-gray-100;
    text-align: center;
    font-size: 12px;
  }

  .c-faqItems {
    &_empty {
      background-color: $color-white;
    }
  }
}
</style>
